import React from 'react';
import styled from 'styled-components';
import type { HBTableFooterProps } from './HBTable.types';
import { useBuildTestIdInternal } from '../../hooks/useBuildTestIdInternal';
import { vars } from '../../theme';
import { TABLE_Z_INDEX } from './HBTable.styles';

function HBTableFooter<T>({ table }: HBTableFooterProps<T>) {
    const { footer } = table.options.meta;

    const testId = useBuildTestIdInternal({
        componentName: 'HBTableFooter',
        identifier: 'footer',
        suffix: 'container'
    });

    if (!footer) {
        return null;
    }

    return <Container data-testid={testId}>{footer}</Container>;
}

export default HBTableFooter;

// -------------------------- Styles -------------------------- //

const Container = styled.div`
    display: flex;
    align-items: center;
    height: 56px;
    padding: 12px 16px;
    background-color: ${vars.colors.surface.container};
    border-top: 1px solid ${vars.colors.stroke.tertiary};
    position: relative;
    z-index: ${TABLE_Z_INDEX.MIDDLE};
`;
